/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, transitions, breakpoints, functions } = theme;
  const { collapseSidenav } = ownerState;
  const { background } = palette;
  const { pxToRem } = functions;
  const sidebarWidth = 240;

  // styles for the sidenav when collapseSidenav={false}
  const drawerOpenStyles = () => ({
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    background: background.sidenav,
    transform: "translateX(0)",

    [breakpoints.up("xl")]: {
      transition: transitions.create(["width"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
      marginBottom: "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
    },
  });

  // styles for the sidenav when collapseSidenav={true}
  const drawerCloseStyles = () => ({
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      marginBottom: "inherit",
      left: "0",
      width: pxToRem(96),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      ...(collapseSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
